
import { Helmet } from "react-helmet-async";

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogImage?: string;
  ogType?: "website" | "article";
  canonicalUrl?: string;
}

const SEO = ({
  title = "Niumora - AI-Powered Business Solutions & Training",
  description = "Transforming businesses through AI-powered solutions and training. Niumora combines artificial intelligence with human expertise to deliver exceptional results.",
  keywords = "AI business solutions, AI training, artificial intelligence business, AI automation, UK business, Niumora",
  ogImage = "/lovable-uploads/513e8760-b016-4254-a9f0-0e6363e59ce4.png",
  ogType = "website",
  canonicalUrl,
}: SEOProps) => {
  const siteTitle = title.includes("Niumora") ? title : `${title} | Niumora`;
  
  return (
    <Helmet>
      <title>{siteTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Canonical URL */}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    </Helmet>
  );
};

export default SEO;
